import React from 'react'
import Async from 'react-promise'
import PageLoader from 'components/PageLoader'
import { signInUri } from 'utils/unifiedLogin'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { getSessionStatus, postSessionBypass } from 'utils/api'

const EnsureSession = ({ children, location, user }) => (
  <Async
    promise={postSessionBypass()}
    pending={() => <PageLoader />}
    then={() => children}
    catch={() =>
      'Only can be used within Decipher until Decipher uses UL to authenticate.'
    }
  />
)

export default connect(state => {
  return {
    user: state.user.user
  }
})(withRouter(EnsureSession))



// WEBPACK FOOTER //
// ./src/components/EnsureSession.js